if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[id^="ProductSubmitButton-"]');

        this.querySelectorAll('.product-panel').forEach((panel) => {
            const toggleButton = panel.querySelector('[aria-controls]');
            if (!toggleButton) return;

            toggleButton.addEventListener('click', () => {
                const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
                const nextExpanded = isExpanded ? 'false' : 'true';

                toggleButton.setAttribute('aria-expanded', nextExpanded);
                panel.dataset.expanded = nextExpanded;
            });
        });

        this.querySelector('#increase-quantity')?.addEventListener('click', (e) => {
            const quantity = this.querySelector('#quantity');
            quantity.value = parseInt(quantity.value) + 1;
        });

        this.querySelector('#decrease-quantity')?.addEventListener('click', (e) => {
            const quantity = this.querySelector('#quantity');
            if (parseInt(quantity.value) > 1)
                quantity.value = parseInt(quantity.value) - 1;
        });

        
        this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      setSubmitButtonLoading(isLoading) {
        if (!this.submitButton) return;
        this.submitButton.classList.toggle('is-loading', isLoading);
        this.submitButton.toggleAttribute('disabled', isLoading);
        this.submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton?.classList.contains('is-loading')) return;
        this.setSubmitButtonLoading(true);

        try {
          if (window.addToCartHandler) {
            await window.addToCartHandler(this.form);
            return;
          }

          // Fallback: direct form submission if cart drawer JS hasn't loaded
          this.form.submit();
        } catch (error) {
          console.error(error);
        } finally {
          if (window.addToCartHandler) {
            this.setSubmitButtonLoading(false);
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
